export enum TYPES {
  SET_LOADING = '@@loading/SET_LOADING'
}

export interface LOADING {
  isLoading: boolean
}
